<!-- 
	ActionEditNews
	props: User
	Allow admin to edit an individual news item
-->

<template>
	<div class="admin-edit-news text-white">
		<div
			v-if="
				user.loggedIn === true && user.additionalData.isStrideAdmin === true
			"
		>
			<div class="text-left">
				<router-link to="/admin-news">
					<CustomButton>Back</CustomButton>
				</router-link>
			</div>
			<EditNews v-bind:user="user" />
		</div>
		<div v-else>
			You must be a Stride Administrator to access this page.<br />If you believe
			this is an error please contact support.
		</div>
	</div>
</template>
<script>
	import { mapGetters } from "vuex";

	import CustomButton from "@/components/CustomButton";
	import EditNews from "@/components/EditNews";

	export default {
		name: "AdminManageNews",
		components: {
			CustomButton,
			EditNews,
		},
		computed: {
			...mapGetters({
				user: "user",
			}),
		},
	};
</script>
